import { render } from "./ChartBuilder.vue?vue&type=template&id=0ca18640"
import script from "./ChartBuilder.vue?vue&type=script&lang=js"
export * from "./ChartBuilder.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/insights/chart-building/ChartBuilder.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0ca18640"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0ca18640', __exports__)) {
    api.reload('0ca18640', __exports__)
  }
  
  module.hot.accept("./ChartBuilder.vue?vue&type=template&id=0ca18640", () => {
    api.rerender('0ca18640', render)
  })

}


export default __exports__